import ParametersIcon from './component'

export default ParametersIcon
